import React, { useState } from "react";
import { Modal, Select, Input, message } from "antd";
import { addDoc, collection, serverTimestamp } from "firebase/firestore";
import { db } from "../../firebaseConfig";
import { useUser } from "../../context/UserContext";

export const MOTIVOS_REPORTE = [
  "Contenido inapropiado u ofensivo",
  "Spam o publicidad engañosa",
  "Fraude o estafa",
  "Producto o servicio prohibido",
  "Acoso o comportamiento abusivo",
  "Otro",
];

/**
 * Modal para reportar contenido de otros usuarios (producto, servicio, reseña, mensaje, tienda).
 * Los reportes se guardan en la colección `reportes` y los revisa un administrador.
 */
const ReportModal = ({ open, onClose, tipo, targetId, targetUid, contexto }) => {
  const { userData } = useUser();
  const [motivo, setMotivo] = useState();
  const [detalle, setDetalle] = useState("");
  const [sending, setSending] = useState(false);

  const handleOk = async () => {
    if (!userData?.uid) return message.warning("Inicia sesión para reportar.");
    if (!motivo) return message.warning("Selecciona un motivo.");
    setSending(true);
    try {
      await addDoc(collection(db, "reportes"), {
        tipo,
        targetId: targetId || null,
        targetUid: targetUid || null,
        contexto: contexto || "",
        motivo,
        detalle: detalle.trim(),
        reporterUid: userData.uid,
        reporterEmail: userData.email || "",
        revisado: false,
        createdAt: serverTimestamp(),
      });
      message.success("Gracias, revisaremos tu reporte en las próximas 24 horas.");
      setMotivo(undefined);
      setDetalle("");
      onClose();
    } catch (error) {
      console.error("Error al enviar reporte:", error);
      message.error("No se pudo enviar el reporte. Intenta de nuevo.");
    } finally {
      setSending(false);
    }
  };

  return (
    <Modal
      title="Reportar contenido"
      open={open}
      centered
      onCancel={onClose}
      onOk={handleOk}
      okText="Enviar reporte"
      cancelText="Cancelar"
      confirmLoading={sending}
    >
      <Select
        style={{ width: "100%", marginBottom: 12 }}
        placeholder="Motivo del reporte"
        value={motivo}
        onChange={setMotivo}
        options={MOTIVOS_REPORTE.map((m) => ({ value: m, label: m }))}
      />
      <Input.TextArea
        rows={4}
        maxLength={500}
        showCount
        placeholder="Cuéntanos más (opcional)"
        value={detalle}
        onChange={(e) => setDetalle(e.target.value)}
      />
    </Modal>
  );
};

export default ReportModal;
